import * as React from 'react'

import { GROUP_INDENT_STEP_PX } from './GroupIndent'

interface IGroupConnectorLinesProps {
  depth: number
  stepPx?: number
  leftOffsetPx?: number
}

// Absolute-positioned so it overlays the flex header without consuming layout width.
export default function GroupConnectorLines({
  depth,
  stepPx = GROUP_INDENT_STEP_PX,
  leftOffsetPx = 16,
}: IGroupConnectorLinesProps): React.ReactElement | null {
  if (depth <= 0) return null
  const lines: React.ReactElement[] = []
  for (let i = 0; i < depth; i++) {
    lines.push(
      <span
        key={i}
        aria-hidden="true"
        className="tw:pointer-events-none tw:absolute tw:top-0 tw:bottom-0 tw:z-10 tw:w-px tw:bg-border"
        style={{ left: i * stepPx + leftOffsetPx }}
      />,
    )
  }
  return <>{lines}</>
}
